// @flow
import dp2_3l1q1 from './l1q1';
import dp2_3l1q2 from './l1q2';
import dp2_3l1q3 from './l1q3';
import dp2_3l1q4 from './l1q4';
import dp2_3l3q1 from './l3q1';
import dp2_3l3q2 from './l3q2';
import dp2_3l3q3 from './l3q3';
import dp2_3l3q4 from './l3q4';
import dp2_3l5q1 from './l5q1';
import dp2_3l5q2 from './l5q2';
import dp2_3l5q3 from './l5q3';
import dp2_3l5q4 from './l5q4';
import dp2_3l7q1 from './l7q1';
import dp2_3l7q2 from './l7q2';
import dp2_3l7q3 from './l7q3';
import dp2_3l7q4 from './l7q4';
import dp2_3l7q5 from './l7q5';

const questions = {
    dp2_3l1q1,
    dp2_3l1q2,
    dp2_3l1q3,
    dp2_3l1q4,
    dp2_3l3q1,
    dp2_3l3q2,
    dp2_3l3q3,
    dp2_3l3q4,
    dp2_3l5q1,
    dp2_3l5q2,
    dp2_3l5q3,
    dp2_3l5q4,
    dp2_3l7q1,
    dp2_3l7q2,
    dp2_3l7q3,
    dp2_3l7q4,
    dp2_3l7q5
}
export default questions;



// WEBPACK FOOTER //
// ./src/constants/dp/questions/cat2.3/index.js